import React, { useEffect, useState } from "react";
import ProfileSidebar from "../ProfileSidebar/ProfileSidebar";
import ProfileInfo from "./ProfileInfo";
import MyAddress from "./MyAddress";
// import Notifications from "./Notifications";
// import ReferralRewards from "./RefferandRewards";
import Layout from "../../Layout/Layout";
import FooterCalendar from "../../Layout/FooterCalendar";
import ReferralRewards from "../../Layout/ReferralRewards";
import FooterNew from "../../Layout/FooterNew";
import SEO from "../../SEO";
import axios from "axios";
const BASE_URL = "https://ecom.cyberathon.com/index.php/Api";
const ProfilePage = () => {
  const [activeTab, setActiveTab] = useState("profile");
const [seoData, setSeoData] = useState({});

   useEffect(() => {
    const fetchSeo = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/get_seo_by_page`, { page_name: 'profile' });

        if (response.data.status === 'true') {
          const data = response.data.data;
          setSeoData({
            title: data.meta_title,
            description: data.meta_description,
            keywords: data.meta_keywords,
            canonical: data.canonical_url,
          });
        }
      } catch (error) {
        console.error('SEO fetch error:', error);
      }
    };

    fetchSeo();
  }, []);
  return (
    <>
    <SEO
      title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
      description={seoData.description || "ShopIndia is the best online shopping platform..."}
      keywords={seoData.keywords || "ShopIndia, online shopping, electronics, clothes, medicines"}
      canonical={seoData.canonical || "https://www.shopindia.com/"}
    />
    <Layout/>
    <div className="container mt-3 mt-md-5" >
      <div className="row">
        {/* Left Sidebar */}
        <div className="col-md-3">
          <ProfileSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>

        {/* Right Content */}
        <div className="col-md-9">
          {activeTab === "profile" && <ProfileInfo/>}
          {activeTab === "address" && <MyAddress />}
          {/* {activeTab === "referrewards" && <ReferralRewards/>} */}
          {/* {activeTab === "review&ratings" && <ProfileInfo />}
          {activeTab === "notifications" && <Notifications />} */}
        </div>
      </div>
    </div>
    {/* <FooterCalendar/> */}
    <FooterNew/>
    </>
  );
};

export default ProfilePage;